var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-failure"},[_c('h1',[_vm._v("申し訳ありませんが、お支払いが完了しませんでした。もう一度お試しいただくか、サポートまでご連絡ください。")]),_c('h5',[_vm._v("Error: "+_vm._s(_vm.msg))]),_c('button',{staticClass:"home-btn btn-comp",on:{"click":function($event){return _vm.goHome()}}},[_vm._v("ログイン")])])
}
var staticRenderFns = []

export { render, staticRenderFns }